import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanMatch,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate, CanMatch {
  constructor(private auth: AuthService, private router: Router) {}

  private checkRole(allowedRoles?: string[]): boolean | UrlTree {
    if (!allowedRoles || allowedRoles.length === 0) {
      return true;
    }
    const currentRole = this.auth.getUserRole();
    if (currentRole && allowedRoles.includes(currentRole)) {
      return true;
    }
    return this.router.createUrlTree(['/admin/dashboard']);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const roles = route.data?.['roles'] as string[] | undefined;
    return this.checkRole(roles);
  }

  canMatch(route: Route, segments: UrlSegment[]): boolean | UrlTree {
    const roles = route.data?.['roles'] as string[] | undefined;
    return this.checkRole(roles);
  }
}
